module.exports = __webpack_public_path__ + "static/media/8000.9bd85730.jpg";